import { DealerProfileType, } from '@masterffl/dealer-profile-component';
import SotModal from './modals/SotForm';

interface TaxStampUploadModalInterface {
  data: DealerProfileType
  isOpen: boolean
  onClose: () => void
}

const SotTaxStampUploadModal = ({ data, isOpen, onClose }: TaxStampUploadModalInterface) => {
  return <>
    <SotModal
      data={data}
      isOpen={isOpen}
      onClose={onClose}
    />
  </>


}

export default SotTaxStampUploadModal;